import React, { useState, useEffect } from "react";
import {
  FaPlus,
  FaEdit,
  FaTrash,
  FaCheckCircle,
  FaSearch,
  FaEye,
  FaEyeSlash,
} from "react-icons/fa";
import axios from "axios";
import Apiurl from "../environment/Apiurl";

const Roles = () => {
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [roles, setRoles] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [editRole, setEditRole] = useState(null);
  const [deleteRoleId, setDeleteRoleId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [currentUserRole, setCurrentUserRole] = useState("Admin");
  const [generatedUserId, setGeneratedUserId] = useState("");

  const roleOptions = ["Admin", "Manager", "Receptionist"];

  const [privileges, setPrivileges] = useState(null);

  // Fetch privileges from localStorage
  useEffect(() => {
    const getaccess = localStorage.getItem("role");
    setPrivileges(getaccess);
  }, []);

  // Fetch all users
  useEffect(() => {
    fetchRoles();
  }, []);
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo({
      top: 0,
      behavior: "smooth", // optional for smooth scrolling
    });
  }, []);

  // Fetch autogenerated user_id when Add Role modal is opened
  useEffect(() => {
    if (showAddModal) {
      fetchGeneratedUserId();
    }
  }, [showAddModal]);

  const fetchRoles = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${Apiurl}/user`);
      setRoles(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching users:", error);
      setError("Failed to fetch users. Please try again.");
      setLoading(false);
    }
  };

  const fetchGeneratedUserId = async () => {
    try {
      const response = await axios.get(`${Apiurl}/generate_user_id`);
      setGeneratedUserId(response.data.user_id);
    } catch (error) {
      console.error("Error fetching generated user ID:", error);
      setError("Failed to fetch generated user ID. Please try again.");
    }
  };

  const handleCloseAddModal = () => {
    setShowAddModal(false);
    setShowPassword(false);
    setGeneratedUserId("");
  };

  const handleCloseEditModal = () => {
    setShowEditModal(false);
    setEditRole(null);
    setShowPassword(false);
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setDeleteRoleId(null);
  };

  const handleAddRole = async (e) => {
    e.preventDefault();
    const form = e.target;
    const roleData = {
      user_id: form.userId.value,
      username: form.username.value,
      password: form.password.value,
      mobile_no: form.mobileNo.value,
      role: form.role.value,
      status: form.roleStatus.value,
    };

    try {
      const response = await axios.post(`${Apiurl}/user`, roleData);
      setRoles([...roles, response.data]);
      form.reset();
      handleCloseAddModal();
    } catch (error) {
      console.error("Error adding user:", error);
      setError("Failed to add user. Please try again.");
    }
  };

  const handleEditRole = async (e) => {
    e.preventDefault();
    const form = e.target;
    const roleData = {
      user_id: editRole.user_id,
      username: form.username.value,
      password: form.password.value || undefined,
      mobile_no: form.mobileNo.value,
      role: form.role.value,
      status: form.roleStatus.value,
    };

    try {
      const response = await axios.put(
        `${Apiurl}/user/${editRole._id}`,
        roleData
      );
      setRoles(
        roles.map((role) => (role._id === editRole._id ? response.data : role))
      );
      handleCloseEditModal();
    } catch (error) {
      console.error("Error updating user:", error);
      setError("Failed to update user. Please try again.");
    }
  };

  const handleDeleteRole = (id) => {
    setDeleteRoleId(id);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    try {
      await axios.delete(`${Apiurl}/user/${deleteRoleId}`);
      setRoles(roles.filter((role) => role._id !== deleteRoleId));
      handleCloseDeleteModal();
    } catch (error) {
      console.error("Error deleting user:", error);
      setError("Failed to delete user. Please try again.");
    }
  };

  const filteredRoles = roles.filter(
    (role) =>
      role.user_id.toLowerCase().includes(searchTerm.toLowerCase()) ||
      (role.username &&
        role.username.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (role.mobile_no &&
        role.mobile_no.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (role.role && role.role.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  const indexOfLastItem = currentPage * parseInt(itemsPerPage);
  const indexOfFirstItem = indexOfLastItem - parseInt(itemsPerPage);
  const currentRoles = filteredRoles.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredRoles.length / parseInt(itemsPerPage));

  const getPageList = () => {
    const pages = [];
    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      if (currentPage <= 4) {
        pages.push(1, 2, 3, 4, 5, "...", totalPages);
      } else if (currentPage >= totalPages - 3) {
        pages.push(
          1,
          "...",
          totalPages - 4,
          totalPages - 3,
          totalPages - 2,
          totalPages - 1,
          totalPages
        );
      } else {
        pages.push(
          1,
          "...",
          currentPage - 1,
          currentPage,
          currentPage + 1,
          "...",
          totalPages
        );
      }
    }
    return pages;
  };

  const pages = getPageList();

  const handlePageClick = (page) => {
    if (page !== "..." && page !== currentPage) {
      setCurrentPage(page);
    }
  };

  if (loading) {
    return (
      <div
        className="container-fluid p-3 d-flex justify-content-center align-items-center"
        style={{ height: "50vh" }}
      >
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid p-3">
      {error && (
        <div
          className="alert alert-danger alert-dismissible fade show"
          role="alert"
        >
          {error}
          <button
            type="button"
            className="btn-close"
            onClick={() => setError(null)}
          ></button>
        </div>
      )}

      <div className="d-flex justify-content-end mb-3">
        {(privileges === "Admin" ||
          privileges === "Manager" ||
          privileges === "Receptionist") && (
          <button
            className="btn btn-sm text-white"
            style={{ backgroundColor: "#2e9290" }}
            onClick={() => setShowAddModal(true)}
          >
            <FaPlus className="me-2" />
            Add User
          </button>
        )}
      </div>

      <div className="card">
        <div className="card-body">
          <div className="row mb-2">
            <div className="col-md-2">
              <div className="input-group">
                <span className="input-group-text">
                  <i className="fas fa-table"></i>
                </span>
                <select
                  className="form-select"
                  value={itemsPerPage}
                  onChange={(e) => {
                    setCurrentPage(1);
                    setItemsPerPage(e.target.value);
                  }}
                >
                  {[5, 10, 20, 50, 100].map((n) => (
                    <option key={n} value={n}>
                      Show {n}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-md-7"></div>
            <div className="col-md-3">
              <div className="d-flex align-items-center">
                <div className="position-relative">
                  <input
                    type="text"
                    className="form-control pe-5"
                    placeholder="Search"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                  <FaSearch
                    className="text-muted"
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th style={{ backgroundColor: "#2e9290", color: "white" }}>
                    S.No
                  </th>
                  <th style={{ backgroundColor: "#2e9290", color: "white" }}>
                    User ID
                  </th>
                  <th style={{ backgroundColor: "#2e9290", color: "white" }}>
                    User Name
                  </th>
                  <th style={{ backgroundColor: "#2e9290", color: "white" }}>
                    Mobile No
                  </th>
                  <th style={{ backgroundColor: "#2e9290", color: "white" }}>
                    Role
                  </th>
                  <th style={{ backgroundColor: "#2e9290", color: "white" }}>
                    Status
                  </th>
                  <th style={{ backgroundColor: "#2e9290", color: "white" }}>
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {currentRoles.length === 0 ? (
                  <tr>
                    <td colSpan="7" className="text-center">
                      {searchTerm
                        ? "No users found matching your search"
                        : "No users available"}
                    </td>
                  </tr>
                ) : (
                  currentRoles.map((role, index) => (
                    <tr key={role._id} className="align-middle">
                      <td>
                        {(currentPage - 1) * parseInt(itemsPerPage) + index + 1}
                      </td>
                      <td>{role.user_id}</td>
                      <td>{role.username}</td>
                      <td>{role.mobile_no}</td>
                      <td>
                        <span
                          className={`badge ${
                            role.role === "Admin"
                              ? "bg-danger"
                              : role.role === "Manager"
                              ? "bg-warning"
                              : "bg-info"
                          }`}
                        >
                          {role.role}
                        </span>
                      </td>
                      <td>
                        <span
                          className={`badge rounded-pill fw-semibold px-3 py-2 d-inline-flex align-items-center gap-1 ${
                            role.status === "Active"
                              ? "bg-success text-white"
                              : "bg-danger text-white"
                          }`}
                        >
                          <FaCheckCircle />
                          {role.status}
                        </span>
                      </td>
                      <td>
                        {(privileges === "Admin" ||
                          privileges === "Manager") && (
                          <button
                            className="btn btn-sm p-1 border-0 me-1"
                            style={{ backgroundColor: "transparent" }}
                            onClick={() => {
                              setEditRole(role);
                              setShowEditModal(true);
                            }}
                          >
                            <FaEdit className="text-primary" />
                          </button>
                        )}

                        {privileges === "Admin" && (
                          <button
                            className="btn btn-sm p-1 border-0"
                            style={{ backgroundColor: "transparent" }}
                            onClick={() => handleDeleteRole(role._id)}
                          >
                            <FaTrash className="text-danger" />
                          </button>
                        )}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {totalPages > 1 && (
            <div className="container">
              <div className="d-flex justify-content-between align-items-center p-3 border-top gap-2">
                <button
                  className="btn btn-outline-secondary d-flex align-items-center gap-2"
                  onClick={() => handlePageClick(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  <i className="fas fa-chevron-left"></i>
                  <span className="d-none d-sm-inline">Previous</span>
                </button>
                <div
                  className="d-flex overflow-auto flex-nowrap gap-2 px-2"
                  style={{ maxWidth: "100%" }}
                >
                  {pages.map((page, index) => (
                    <button
                      key={index}
                      className={`btn btn-sm px-3 flex-shrink-0 ${
                        page === currentPage
                          ? "text-white"
                          : "btn-outline-secondary"
                      }`}
                      style={
                        page === currentPage
                          ? { backgroundColor: "#2e9290", border: "none" }
                          : {}
                      }
                      onClick={() => handlePageClick(page)}
                      disabled={page === "..."}
                    >
                      {page}
                    </button>
                  ))}
                </div>
                <button
                  className="btn btn-outline-secondary d-flex align-items-center gap-2"
                  onClick={() => handlePageClick(currentPage + 1)}
                  disabled={currentPage === totalPages}
                >
                  <span className="d-none d-sm-inline">Next</span>
                  <i className="fas fa-chevron-right"></i>
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Add User Modal */}
      {showAddModal && (
        <div
          className="modal fade show d-block"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
          tabIndex="-1"
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header border-0">
                <h5 className="modal-title">Add User</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleCloseAddModal}
                ></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleAddRole}>
                  <div className="mb-3">
                    <label className="form-label">User ID</label>
                    <input
                      type="text"
                      name="userId"
                      className="form-control"
                      value={generatedUserId}
                      readOnly
                      placeholder="Generating User ID..."
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">User Name</label>
                    <input
                      type="text"
                      name="username"
                      className="form-control"
                      placeholder="Enter User Name"
                      required
                    />
                  </div>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Password</label>
                      <div className="position-relative">
                        <input
                          type={showPassword ? "text" : "password"}
                          name="password"
                          className="form-control pe-5"
                          placeholder="Enter password"
                          required
                        />
                        <button
                          type="button"
                          className="btn btn-sm position-absolute end-0 top-0 mt-2 me-2"
                          onClick={() => setShowPassword(!showPassword)}
                        >
                          {showPassword ? <FaEyeSlash /> : <FaEye />}
                        </button>
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Mobile No</label>
                      <input
                        type="tel"
                        name="mobileNo"
                        className="form-control"
                        placeholder="Enter 10-digit mobile number"
                        required
                        minLength={10}
                        maxLength={10}
                        pattern="[0-9]{10}"
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          );
                        }}
                        title="Please enter exactly 10 digits"
                      />
                    </div>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Role</label>
                    <select name="role" className="form-select" required>
                      <option value="">Select role</option>
                      {roleOptions.map((role) => (
                        <option key={role} value={role}>
                          {role}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Status</label>
                    <select
                      name="roleStatus"
                      className="form-select"
                      defaultValue="Active"
                    >
                      <option value="Active">Active</option>
                      <option value="Inactive">Inactive</option>
                    </select>
                  </div>
                  <div className="d-flex justify-content-end gap-2">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={handleCloseAddModal}
                    >
                      Close
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary"
                      style={{ backgroundColor: "#2e9290", border: "none" }}
                      disabled={!generatedUserId}
                    >
                      Add User
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Edit User Modal */}
      {showEditModal && (
        <div
          className="modal fade show d-block"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
          tabIndex="-1"
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header border-0">
                <h5 className="modal-title">Edit User</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleCloseEditModal}
                ></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleEditRole}>
                  <div className="mb-3">
                    <label className="form-label">User ID</label>
                    <input
                      type="text"
                      name="userId"
                      className="form-control"
                      defaultValue={editRole ? editRole.user_id : ""}
                      readOnly
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">User Name</label>
                    <input
                      type="text"
                      name="username"
                      className="form-control"
                      defaultValue={editRole ? editRole.username : ""}
                      placeholder="Enter User Name"
                      required
                    />
                  </div>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Password</label>
                      <div className="position-relative">
                        <input
                          type={showPassword ? "text" : "password"}
                          name="password"
                          className="form-control pe-5"
                          placeholder="Enter new password (optional)"
                          defaultValue={editRole ? editRole.password : ""}
                        />

                        <button
                          type="button"
                          className="btn btn-sm position-absolute end-0 top-0 mt-2 me-2"
                          onClick={() => setShowPassword(!showPassword)}
                        >
                          {showPassword ? <FaEyeSlash /> : <FaEye />}
                        </button>
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Mobile No</label>
                      <input
                        type="tel"
                        name="mobileNo"
                        className="form-control"
                        defaultValue={editRole ? editRole.mobile_no : ""}
                        placeholder="Enter 10-digit mobile number"
                        required
                        minLength={10}
                        maxLength={10}
                        pattern="[0-9]{10}"
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          );
                        }}
                        title="Please enter exactly 10 digits"
                      />
                    </div>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Role</label>
                    <select
                      name="role"
                      className="form-select"
                      defaultValue={editRole ? editRole.role : ""}
                      required
                    >
                      <option value="">Select role</option>
                      {roleOptions.map((role) => (
                        <option key={role} value={role}>
                          {role}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Status</label>
                    <select
                      name="roleStatus"
                      className="form-select"
                      defaultValue={editRole ? editRole.status : "Active"}
                    >
                      <option value="Active">Active</option>
                      <option value="Inactive">Inactive</option>
                    </select>
                  </div>
                  <div className="d-flex justify-content-end gap-2">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={handleCloseEditModal}
                    >
                      Close
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary"
                      style={{ backgroundColor: "#2e9290", border: "none" }}
                    >
                      Update User
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Delete Confirmation Modal */}
      {showDeleteModal && (
        <div
          className="modal fade show d-block"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
          tabIndex="-1"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header border-0">
                <h5 className="modal-title">Confirm Delete</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleCloseDeleteModal}
                ></button>
              </div>
              <div className="modal-body">
                <p>
                  Are you sure you want to delete the user{" "}
                  {roles.find((r) => r._id === deleteRoleId)?.user_id}?
                </p>
                <div className="d-flex justify-content-end gap-2">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={handleCloseDeleteModal}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={confirmDelete}
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Roles;
